jQuery(document).ready(function($) {
  if (!$('.mobile-link').length) {
    return;
  }

  if ($(window).width() <= 768) {
    $('.mobile-link').on('click', function() {
      $(this).toggleClass('hide');
      $($(this).data('content')).toggleClass('hide');
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/components/mobile-link.js